import { Drawer, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { usePageModalStore } from "../stores/ModalState";
import FinanceDetails from "../pages/FinanceDetails";

const PageDrawer = () => {
  const { isOpen, data, closeModal } = usePageModalStore();

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={closeModal}
      sx={{
        "& .MuiDrawer-paper": {
          width: "550px",
          maxWidth: "80vw",
          backgroundColor: "#232323",
          boxShadow: "none",
          "--Paper-overlay": "none",
        },
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        px={2}
        py={1.5}
        sx={{ backgroundColor: "#232323" }}
      >
        <Typography variant="h6" fontWeight={700}>
          Detalhes da transação
        </Typography>
        <IconButton aria-label="close" onClick={closeModal}>
          <CloseIcon />
        </IconButton>
      </Stack>

      <Stack p={2} sx={{ overflowY: "auto", backgroundColor: "#232323" }}>
        {data?.id && <FinanceDetails id={data.id} />}
      </Stack>
    </Drawer>
  );
};

export default PageDrawer;
